import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-no-data",
  "use": "icon-no-data-usage",
  "viewBox": "0 0 80 81",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 81\" id=\"icon-no-data\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 .686h80v80H0z\" /><path fill=\"#E6EAE8\" d=\"M16.796 19.836h21.496v6.112H16.796zm0 10.913h40v6.112h-40z\" /><path stroke=\"#E6EAE8\" stroke-width=\"2\" d=\"M44.456 66.513H14a1.6 1.6 0 0 1-1.6-1.6v-51.2a1.6 1.6 0 0 1 1.6-1.6h35.088v11.338a.8.8 0 0 0 .8.8H62v15.574M49.322 11.886l12.913 12.137\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol